import type { ColumnConfig, ConfigTableProps } from '@/components/datatable/dataTableTypes';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'partnerName' },
  { field: 'amount' },
  { field: 'currency' },
  { field: 'paymentType', type: 'enum' },
];

export const tableConfig: ConfigTableProps = {};
